module.exports = __webpack_public_path__ + "static/media/disable_mic.639c81dd.svg";